/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import prettyBytes from 'pretty-bytes';

export const getUnit = (bytes: number) => {
  const [, unit] = prettyBytes(bytes).split(' ');
  return unit;
};

export const findIndex = <T>(arr: T[], searchValue: T): number | undefined => {
  const index = arr.indexOf(searchValue);
  return index === -1 ? undefined : index;
};
